import React from 'react';
import { RefreshCw, LogOut, WifiOff } from 'lucide-react';
import { Button } from './ui/button';
import { useAuth } from '../context/AuthContext';

export const SessionRecovery = () => {
  const { sessionError, retrySession, logout } = useAuth();
  return (
    <main data-testid="session-recovery" className="min-h-screen flex items-center justify-center bg-gradient-to-br from-white to-emerald-50 px-6 py-12">
      <section className="w-full max-w-lg">
        <p className="font-bold text-teal-700 mb-10">SitePe</p>
        <WifiOff className="w-9 h-9 text-rose-600 mb-6" aria-hidden="true" />
        <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-5">Connection paused</h1>
        <p role="alert" data-testid="session-recovery-error" className="text-sm sm:text-base leading-relaxed text-gray-600 mb-8 break-words">{sessionError}</p>
        <div className="flex flex-wrap gap-3">
          <Button data-testid="session-recovery-retry" onClick={retrySession} className="bg-teal-700 hover:bg-teal-800"><RefreshCw className="w-4 h-4 mr-2" />Retry connection</Button>
          <Button data-testid="session-recovery-sign-out" onClick={logout} variant="outline"><LogOut className="w-4 h-4 mr-2" />Sign out</Button>
        </div>
      </section>
    </main>
  );
};